import React from 'react';
import SvgArrow from 'components/SvgArrow/SvgArrow';

const DEPENDENCY_LINE_COLOR = 'var(--aha-gray-800)';
const DEPENDENCY_LINE_HOVER_COLOR = 'var(--aha-gray-900)';
const BROKEN_DEPENDENCY_LINE_COLOR = 'var(--aha-red-700)';
const BROKEN_DEPENDENCY_LINE_HOVER_COLOR = 'var(--aha-red-600)';

interface DependencyLink {
  id: string;
  childPath: string;
  parentPath: string;
}

interface BarPosition {
  top: number;
  height: number;
  left: number;
  right: number;
}

// Maps the id of the dependency to it's position on the page
interface BarPositionMap {
  [linkdId: string]: BarPosition;
}

interface DependencyLinesProps {
  barPositions: BarPositionMap;
  dependencyLinks: DependencyLink[];
}

const DependencyLines: React.FC<DependencyLinesProps> = ({
  barPositions,
  dependencyLinks,
}) => {
  const linkLines: Array<React.ReactNode> = [];

  if (barPositions != null) {
    dependencyLinks.forEach(link => {
      const depStartBarPos = barPositions[link.childPath];
      const depEndBarPos = barPositions[link.parentPath];

      if (depStartBarPos && depEndBarPos) {
        const isBroken = depStartBarPos.right > depEndBarPos.left;

        const color = isBroken
          ? BROKEN_DEPENDENCY_LINE_COLOR
          : DEPENDENCY_LINE_COLOR;
        const hoverColor = isBroken
          ? BROKEN_DEPENDENCY_LINE_HOVER_COLOR
          : DEPENDENCY_LINE_HOVER_COLOR;

        linkLines.push(
          <SvgArrow
            key={`${link.childPath}::${link.parentPath}`}
            id={link.id}
            startPoint={{
              x: depStartBarPos.right,
              y: depStartBarPos.top + depStartBarPos.height / 2,
            }}
            endPoint={{
              x: depEndBarPos.left,
              y: depEndBarPos.top + depStartBarPos.height / 2,
            }}
            color={color}
            hoverColor={hoverColor}
            centerOffset={25}
            verticalArrowSpacingHeight={depStartBarPos.height / 2}
            filter={false}
          />
        );
      }
    });
  }

  return <div className='timeline-chart__dependency-lines'>{linkLines}</div>;
};

export default React.memo(DependencyLines);
